import { orange, red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string;
      success: string;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    status?: {
      danger?: string;
      alert?: string;
      success?: string;
    };
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#312783',
    },
    secondary: {
      main: '#F39200',
      contrastText: '#ffffff',
    },
    background: {
      paper: '#fff',
      default: '#fcfcfc',
    },
  },
  status: {
    alert: orange[500],
    danger: red[500],
  },
});

export default theme;
